import tools from "@/utils/tools"

export default class AppUser {
  #cargoTypeID
  #cargoTypeName
  #name
  #shortName
  #role
  #permissions

  constructor({ name, cargoTypeID, cargoTypeName, role, permissions }) {
    this.#cargoTypeID = cargoTypeID
    this.#cargoTypeName = cargoTypeName
    this.#name = name
    this.#shortName = tools.shortFIO(name)
    this.#role = role
    this.#permissions = permissions
  }

  get name() {
    return this.#name
  }

  get shortName() {
    return this.#shortName
  }

  get role() {
    return this.#role
  }

  get cargoTypeID() {
    return this.#cargoTypeID
  }

  get cargoTypeName() {
    return this.#cargoTypeName
  }

  get anyCargoType() {
    return !this.#cargoTypeID
  }

  havePermission(permission) {
    return this.#permissions.some(x => x === permission)
  }
}
